module.exports = __webpack_public_path__ + "static/media/marksSample.0c9dc877.xls";